export default __webpack_public_path__ + "static/media/Follow me.68dc7e7d.jpg";